export const dashboardTasksData = [
  {
    key: "t1",
    title: "Controleer expert rapport",
    assignee: "J. de Vries",
    priority: "high",
  },
  {
    key: "t2",
    title: "Bel verzekeraar over calculatie",
    assignee: "M. Janssen",
    priority: "medium",
  },
  {
    key: "t3",
    title: "Verstuur reminder image capture",
    assignee: "S. Bakker",
    priority: "medium",
  },
  {
    key: "t4",
    title: "Finaliseer dossier D-2024-004",
    assignee: "H. Willems",
    priority: "medium",
  },
];
